import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { AlertMessage } from "./alert-message.model";

@Injectable()
export class AlertMessageService {
	protected static errors = new Subject<AlertMessage>();
	static errorsState = AlertMessageService.errors.asObservable();
	protected static warnings = new Subject<AlertMessage>();
	static warningsState = AlertMessageService.warnings.asObservable();

	newError(error: AlertMessage): void {
		AlertMessageService.errors.next(error);
	}

	newWarning(warn: AlertMessage): void {
		AlertMessageService.warnings.next(warn);
	}
}